var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable react/button-has-type */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import SafeAnchor from './SafeAnchor';

var Button = (_temp2 = _class = function (_React$Component) {
  _inherits(Button, _React$Component);

  function Button() {
    var _temp, _this, _ret;

    _classCallCheck(this, Button);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (e) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          loading = _this$props.loading,
          onClick = _this$props.onClick;


      if (disabled || loading) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }

      if (onClick) {
        onClick(e);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Button.prototype.render = function render() {
    var _classNames;

    var _props = this.props,
        block = _props.block,
        children = _props.children,
        className = _props.className,
        disabled = _props.disabled,
        href = _props.href,
        loading = _props.loading,
        ocSize = _props.ocSize,
        ocStyle = _props.ocStyle,
        onBlur = _props.onBlur,
        onClick = _props.onClick,
        onFocus = _props.onFocus,
        onMouseOut = _props.onMouseOut,
        onMouseOver = _props.onMouseOver,
        rounded = _props.rounded,
        type = _props.type,
        other = _objectWithoutProperties(_props, ['block', 'children', 'className', 'disabled', 'href', 'loading', 'ocSize', 'ocStyle', 'onBlur', 'onClick', 'onFocus', 'onMouseOut', 'onMouseOver', 'rounded', 'type']);

    var btnProps = {
      className: classNames('btn', className, (_classNames = {
        'btn-block': block,
        'btn-rounded': rounded
      }, _classNames['btn-' + ocSize] = ocSize, _classNames['btn-' + ocStyle] = ocStyle, _classNames.disabled = disabled, _classNames.loading = loading, _classNames)),
      disabled: disabled,
      onBlur: onBlur,
      onClick: this.handleClick,
      onFocus: onFocus,
      onMouseOut: onMouseOut,
      onMouseOver: onMouseOver
    };

    if (href) {
      return React.createElement(
        SafeAnchor,
        _extends({ href: href }, btnProps, other),
        children
      );
    }

    return React.createElement(
      'button',
      _extends({ type: type }, btnProps, other),
      children
    );
  };

  return Button;
}(React.Component), _class.defaultProps = {
  block: false,
  disabled: false,
  loading: false,
  ocStyle: 'primary',
  rounded: false,
  type: 'button'
}, _temp2);
export { Button as default };
Button.propTypes = process.env.NODE_ENV !== "production" ? {
  block: PropTypes.bool,
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  href: PropTypes.string,
  loading: PropTypes.bool,
  ocSize: PropTypes.oneOf(['xs', 'sm', 'lg']),
  ocStyle: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'cancel', 'upload', 'success', 'info', 'warning', 'danger', 'link']),
  onBlur: PropTypes.func,
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
  onMouseOut: PropTypes.func,
  onMouseOver: PropTypes.func,
  rounded: PropTypes.bool,
  type: PropTypes.oneOf(['button', 'reset', 'submit'])
} : {};